import { ref } from 'vue'
import { isLargeViewPort as detectIsLargeViewPort } from '@remote/utils/base'

const isLargeViewPort = ref<boolean>(detectIsLargeViewPort())

const onWindowResize = () => {
  isLargeViewPort.value = detectIsLargeViewPort()
}

export function useIsLargeViewport ():void {
  window.addEventListener('resize', onWindowResize)
}

export default isLargeViewPort